import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import matchSorter from "match-sorter";

import * as modalActions from "../../../actions/modalActions";
import * as projectActions from "../../../actions/projectActions";

import HeaderWrapper from "../../common/HeaderWrapper";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";
import ProjectNotificationsList from "./ProjectNotificationsList";
import ProjectNotificationsForm from "./ProjectNotificationsForm";

const ProjectNotificationsPage = ({
  project,
  codes,
  isMobile,
  actions,
  projectNotificationToDelete
}) => {
  const [loading] = useState(false);
  const [adding, setAdding] = useState(false);
  const [notification, setNotificiation] = useState({});

  const onClickAdd = () => {
    setAdding(true);
    setNotificiation({});
    actions.showModalSuccess("notificationDetailsModal");
  };

  const onClickView = (notificationId) => {
    setAdding(false);
    const notificationSelcted = project.notifications.find(
      (n) => n._id === notificationId
    );
    setNotificiation(notificationSelcted);
    actions.showModalSuccess("notificationDetailsModal");
  };

  const onClickDelete = (notificationId) => {
    actions.requestNotificationId(notificationId);
  };

  const handleDelete = () => {
    actions.deleteNotification(project._id, projectNotificationToDelete);
  };

  const handleAdd = (item) => {
    actions.createNotification(project._id, item);
  };

  const handleSave = (item) => {
    actions.updateNotification(project._id, item);
  };

  const notificationForm = (
    <ProjectNotificationsForm
      project={project}
      notification={notification}
      codes={codes}
      adding={adding}
      onAdd={handleAdd}
      onSave={handleSave}
      onCancel={actions.hideModal}
    />
  );
  return (
    <div id="notifications">
      <HeaderWrapper
        breadcrumbs={[{ label: "Notifications" }]}
        onClickAdd={onClickAdd}
        isMobile={isMobile}
      />
      <ProjectNotificationsList
        data={matchSorter(project.notifications, "", {
          keys: ["type.label", "num_days"]
        })}
        loading={loading}
        isMobile={isMobile}
        onClickView={onClickView}
        onClickDelete={onClickDelete}
      />
      <Modal
        id="notificationDetailsModal"
        title={adding ? "Add Notification" : "Edit Notification"}
        body={notificationForm}
        close={actions.hideModal}
      />
      <ConfirmModal
        id="notificationDeleteModal"
        title="Delete Project Notification"
        body="Are you sure you want to delete this notifiation?"
        close={actions.hideModal}
        confirm={handleDelete}
      />
    </div>
  );
};

ProjectNotificationsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  project: PropTypes.object,
  isMobile: PropTypes.bool,
  codes: PropTypes.array.isRequired,
  projectNotificationToDelete: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    project: state.reducers.project,
    codes: state.reducers.codes,
    projectNotificationToDelete: state.reducers.projectNotificationToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...projectActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(ProjectNotificationsPage)
);
